import { ScopingInfo } from '@models/interfaces';

export const TRANSFORM_SCOPING_DATES: Array<
  keyof Omit<ScopingInfo, 'otherEquipments' | 'scopingSectorsVersions'>
> = ['scheduledScopingDate'];
